import { KeycloakProfile } from 'keycloak-js';

import { FeatureFlags } from 'yeself-common/typings/FeatureFlags';

export const AUTH_INIT_REQUEST = 'security/AUTH_INIT_REQUEST';
export const AUTH_INIT_SUCCESS = 'security/AUTH_INIT_SUCCESS';
export const AUTH_INIT_FAIL = 'security/AUTH_INIT_FAIL';
export const AUTH_LOGIN_REQUEST = 'security/AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'security/AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAIL = 'security/AUTH_LOGIN_FAIL';
export const AUTH_LOGOUT_REQUEST = 'security/AUTH_LOGOUT_REQUEST';
export const AUTH_LOGOUT_SUCCESS = 'security/AUTH_LOGOUT_SUCCESS';
export const AUTH_LOGOUT_FAIL = 'security/AUTH_LOGOUT_FAIL';
export const AUTH_SET_USER_PROFILE = 'security/AUTH_SET_USER_PROFILE';
export const AUTH_SET_USER_ROLES = 'security/AUTH_SET_USER_ROLES';
export const AUTH_SET_ACCOUNT_URL = 'security/AUTH_SET_ACCOUNT_URL';
export const AUTH_SET_TOKEN = 'security/AUTH_SET_TOKEN';

export const AUTH_BUS_LOGIN_REQUEST = 'security/bus/AUTH_LOGIN_REQUEST';
export const AUTH_BUS_LOGOUT_REQUEST = 'security/bus/AUTH_LOGOUT_REQUEST';
export const AUTH_BUS_SUCCESS = 'security/bus/AUTH_SUCCESS';
export const AUTH_BUS_FAIL = 'security/bus/AUTH_FAIL';

export const USER_TENANT = {
    STABLE: 'stable',
    CANARY: 'canary',
} as const;

export type SecurityState = {
    isLogged: boolean;
    isFailed: boolean;
    isLoading: boolean;
    accountUrl: string;
    user: SecurityProfile;
    roles: string[];
    options: SecurityInitOptions;
    token?: string;
};

export type SecurityProfile = KeycloakProfile & {
    groups: string[];
    attributes: {
        tenant: [string];
    };
    featureFlags: FeatureFlags | Record<string, never>;
};

export type SecurityInitOptions = {
    loginRequired: boolean;
    loginFromIFrame: boolean;
};

export type SecurityOptions = {
    url: string;
    realm: string;
    clientId: string;
};

export type SecurityTokenPayload = {
    token: string;
    refreshToken: string;
    idToken: string;
};

type AuthBusLoginRequestAction = {
    type: typeof AUTH_BUS_LOGIN_REQUEST;
};

type AuthBusLogoutRequestAction = {
    type: typeof AUTH_BUS_LOGOUT_REQUEST;
};

type AuthBusSuccessAction = {
    type: typeof AUTH_BUS_SUCCESS;
    payload: SecurityTokenPayload;
};

type AuthBusFailAction = {
    type: typeof AUTH_BUS_FAIL;
};

type AuthInitRequestAction = {
    type: typeof AUTH_INIT_REQUEST;
    payload: SecurityInitOptions;
};

type AuthInitSuccessAction = {
    type: typeof AUTH_INIT_SUCCESS;
};

type AuthInitFailAction = {
    type: typeof AUTH_INIT_FAIL;
};

type AuthLogoutRequestAction = {
    type: typeof AUTH_LOGOUT_REQUEST;
};

type AuthLogoutSuccessAction = {
    type: typeof AUTH_LOGOUT_SUCCESS;
};

type AuthLogoutFailAction = {
    type: typeof AUTH_LOGOUT_FAIL;
};

type AuthLoginRequestAction = {
    type: typeof AUTH_LOGIN_REQUEST;
};

type AuthLoginSuccessAction = {
    type: typeof AUTH_LOGIN_SUCCESS;
    payload: string;
};

type AuthLoginFailAction = {
    type: typeof AUTH_LOGIN_FAIL;
};

type AuthSetUserProfileAction = {
    type: typeof AUTH_SET_USER_PROFILE;
    payload: SecurityProfile;
};

type AuthSetAccountUrlAction = {
    type: typeof AUTH_SET_ACCOUNT_URL;
    payload: string;
};

type AuthSetUserRolesAction = {
    type: typeof AUTH_SET_USER_ROLES;
    payload: string[];
};

type AuthSetTokenAction = {
    type: typeof AUTH_SET_TOKEN;
    payload: string;
};

export type SecurityBusActionTypes =
    | AuthBusFailAction
    | AuthBusSuccessAction
    | AuthBusLoginRequestAction
    | AuthBusLogoutRequestAction;

export type SecurityActionTypes =
    | AuthInitFailAction
    | AuthInitRequestAction
    | AuthInitSuccessAction
    | AuthLoginFailAction
    | AuthLoginRequestAction
    | AuthLoginSuccessAction
    | AuthLogoutFailAction
    | AuthLogoutRequestAction
    | AuthLogoutSuccessAction
    | AuthSetAccountUrlAction
    | AuthSetUserProfileAction
    | AuthSetUserRolesAction
    | AuthSetTokenAction;
